import { CHANGETHEME } from './darkmode.types';

export const changeTheme = () => {
	return {
		type: CHANGETHEME,
	};
};